export const ANIMATION_EVENT_NAMES = {
    CLOSE_ALL: 'close_all',
    FIRST_START: 'first_start',
} as const;
